module.exports = __webpack_public_path__ + "static/media/qoe.23f50784.pdf";